import React, { useState } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import Head from '../components/Head';
import Header from '../components/Header/Header';
import PreviewBar from '../components/PreviewBar';
import GlobalStyle from '../styling/global';
import theme from '../styling/theme';

const Wrapper = styled.div`
  background: var(--color-primary);
  position: relative;
  z-index: 2;
`;

const Layout = ({ meta, languageSwitch, navigation, headerData, preview, children }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  function scrollFunction() {
    if (window.scrollY > 10 && !isScrolled) {
      setIsScrolled(true);
    } else if (window.scrollY <= 10 && isScrolled) {
      setIsScrolled(false);
    }
  }

  if (typeof window !== 'undefined') {
    window.onscroll = scrollFunction;
  }
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Head meta={meta} />
      {preview && <PreviewBar />}
      <Wrapper>
        <Header
          languageSwitch={languageSwitch}
          navigation={navigation}
          headerData={headerData}
          isScrolled={isScrolled}
        />
        <main>{children}</main>
      </Wrapper>
    </ThemeProvider>
  );
};

export default Layout;
